<template>
  <v-container class="py-0">
    <v-breadcrumbs :items="items" divider=">">
      <template v-slot:divider>
        <v-icon>
          $chevronRight
        </v-icon>
      </template>
    </v-breadcrumbs>
  </v-container>
</template>
<style lang="scss">
.v-breadcrumbs {
  padding: 12px 0 !important;
}
.v-breadcrumbs__item {
  color: $text-color !important;
}
.v-breadcrumbs__item--disabled {
  color: $text-color !important;
  font-weight: bold;
}
.v-breadcrumbs li .v-icon {
  font-size: 12px;
  font-weight: bold;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .v-breadcrumbs {
    padding: 10px 0 0px 0;
  }
}
</style>
<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  jsonld() {
    const items = this.items.map((item, index) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@id": typeof item.to === "object" ? item.to.name : item.to,
          name: item.text
        }
      };
    });
    return {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items
    };
  }
};
</script>
